document.addEventListener("DOMContentLoaded", function () {
  const selectElement = document.getElementById("SortBy");
  const urlParams = new URLSearchParams(window.location.search);
  const sortByParam = urlParams.get("sort_by");
  if (!sortByParam) {
    selectElement.value = "best-selling";

    urlParams.set("sort_by", "best-selling");

    const newUrl = window.location.pathname + "?" + urlParams.toString();

    window.history.replaceState(null, "", newUrl);

    window.location.reload();
  }
});